import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {Asset, AssetSearchParams} from '@accounting/_common/models/asset.models';
import {CategoryListResponse, EntityCategoryTree} from '@common/components-standalone/reference-category-module/category.type';
import {CategoriesTreeState} from '@common/models/entity-state.models';

export const CheckState = createAction(
    '[Assets] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: Asset[] } }>()
);

export const CheckStateSuccess = createAction(
    '[Assets] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: Asset[] } }>()
);

export const LoadCategories = createAction(
    '[Assets] Load Categories',
    props<{ forceUpdate: boolean }>()
);

export const LoadCategoriesSuccess = createAction(
    '[Assets] Load Categories Success',
    props<{ payload: CategoryListResponse[] }>()
);

export const UpsertCategory = createAction(
    '[Assets] Upsert Category',
    props<{ payload: CategoryListResponse }>()
);

export const DeleteCategory = createAction(
    '[Assets] Delete Category',
    props<{ payload: EntityCategoryTree }>()
);

export const SetCategoriesState = createAction(
    '[Assets] Set Categories State',
    props<{ payload: CategoriesTreeState }>()
);

export const LoadList = createAction(
    '[Assets] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Assets] Load List Success',
    props<{ payload: { items: Asset[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Assets] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[Assets] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[Assets] Set Filter',
    props<{ payload: AssetSearchParams, selectedCategory?: EntityCategoryTree }>()
);

export const SetLoading = createAction(
    '[Assets] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[Assets] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[Assets] Update Item Success',
    props<{ payload: Asset }>()
);

export const DeleteItem = createAction(
    '[Assets] Delete Item',
    props<{ payload: Asset }>()
);

export const DeleteItemSuccess = createAction(
    '[Assets] Delete Item Success',
    props<{ payload: Asset }>()
);

export const DeleteItemFailure = createAction(
    '[Assets] Delete Item Failure',
    props<{ payload: Asset }>()
);

export const SetInitialState = createAction(
    '[Assets] Set Initial State'
);

export const UpdateAssetItem = createAction(
    '[Assets] Update Asset Item',
    props<{ payload: Asset }>()
);
